import { render, staticRenderFns } from "./registerAccess.vue?vue&type=template&id=b4c65c42&"
import script from "./registerAccess.vue?vue&type=script&lang=js&"
export * from "./registerAccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports